function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}
$(document).ready(function() {
	var lang = window.location.pathname.split("/")[1].toLowerCase();

	$("#submit-contact-form").on("click tap", function() {
		var email = $("#mail-contact").val();
		var text = "";
		var classError = "";
		if (validateEmail(email)) {
			console.log(email);
			$.post(
				"/mail-list/subscribe",
				{
					email: email,
					lang: lang
				},
				function(data) {
					console.log(data);
					var res = JSON.parse(data);
					console.log(typeof res, res.status);
					classError = "green";
					switch (res.status) {
						case "subscribed":
							switch (lang) {
								case "it":
									text =
										"Ti sei registrato correttamente alla newsletter della Prima Automotive!";
									break;
								case "en":
									console.log("RESPO true");
									text =
										"You have registered correctly with Prima Automotive newsletters!";
									break;
								default:
							}
							break;
						case 400:
							switch (lang) {
								case "it":
									text = "Sei già iscritto alla newsletter!";
									break;
								case "en":
									text = email + " is already a member of newsletter";
									break;
								default:
							}
						default:
					}
					$(".footer-box-contacts .error").removeClass("red green");
					$(".footer-box-contacts .error").addClass(classError);
					$(".footer-box-contacts .error span").text(text);
				}
			);
		} else {
			//email non valida
			classError = "red";

			switch (lang) {
				case "it":
					text = "Email non valida";
					break;
				case "en":
					text = "Invalid Email";
					break;
				default:
			}
		}
		console.log(classError, text);
		$(".footer-box-contacts .error").removeClass("red green");
		$(".footer-box-contacts .error").addClass(classError);
		$(".footer-box-contacts .error span").text(text);
	});
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_mail-list.js
// module id = 10
// module chunks = 0